import { useTenant } from 'probonio-shared-ui/module/me';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { getBenefitNavigation } from '../../../extension/interface/benefit-navigation.extension.interface';
import { useNavigateWithPrevPath } from '../../../util/useNavigateWithPrevPath';
import { getBenefitIcon } from '../BenefitIcon';
import { useDocumentsQuery } from '../useDocumentsQuery';
import { BenefitMenuItem } from './BenefitMenuItem';

export const BenefitButton: React.FC<{
  active?: boolean;
  selected: boolean;
  onShowFallback?: () => void;
  benefitMetadata: BenefitMetadataExtensionInterface;
}> = ({ active = true, onShowFallback, selected, benefitMetadata }) => {
  const { t } = useTranslation();
  const navigate = useNavigateWithPrevPath();
  const { tenant } = useTenant();
  const benefit = benefitMetadata.benefitId;
  const { data: documents } = useDocumentsQuery({ enabled: selected, benefit });

  const benefitNavigationProvider = getBenefitNavigation(benefitMetadata.benefitId);

  const handleClick = useCallback(() => {
    if (benefit && active) {
      navigate(`/benefits/${benefit.toLowerCase()}`);
    } else if (onShowFallback) {
      onShowFallback();
    }
  }, [benefit, active, navigate, onShowFallback]);

  return (
    <BenefitMenuItem
      selected={selected}
      icon={getBenefitIcon(benefit)}
      title={t(`common:benefit.${benefit}`)}
      onClick={handleClick}
      active={active}
      dataTestId={`${benefit.toLowerCase()}-benefit-button`}
      subMenuItems={benefitNavigationProvider?.getMenuItems({ tenant, documents })}
    />
  );
};
